import React, { useState, useEffect, useRef } from "react";
import { Box, Button } from "@mui/material";
import BlogCard from "./CustomCard4";

const MobileSlider = ({ cardData2 }) => {
  const [cards, setCards] = useState([...cardData2]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const touchStartX = useRef(null);
  const touchEndX = useRef(null);
  const autoSlideRef = useRef();

  // Load more when near end
  const loadMoreData = () => {
    const newCards = cardData2.map((card, idx) => ({
      ...card,
      card_id: `${cards.length}-${idx}`, // Ensure uniqueness
    }));
    setCards((prev) => [...prev, ...newCards]);
  };

  // Auto slide
  useEffect(() => {
    autoSlideRef.current = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        const nextIndex = prevIndex + 1;
        if (nextIndex >= cards.length - 2) loadMoreData();
        return nextIndex;
      });
    }, 3000);
    return () => clearInterval(autoSlideRef.current);
  }, [cards]);

  

  // Swipe handling
  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (touchStartX.current === null || touchEndX.current === null) return;
    const deltaX = touchStartX.current - touchEndX.current;

    if (deltaX > 50) {
      setCurrentIndex((prev) => {
        const next = prev + 1;
        if (next >= cards.length - 2) loadMoreData();
        return next;
      });
    } else if (deltaX < -50) {
      setCurrentIndex((prev) => (prev > 0 ? prev - 1 : 0));
    }

    touchStartX.current = null;
    touchEndX.current = null;
  };

  const getTranslateX = () => {
    return `calc(47vw - 37.5vw - ${currentIndex * 75}vw)`;
  };

  return (
    <Box
      sx={{
        width: "94vw",
        overflow: "hidden",
        display: { xs: "block", sm: "none" },
        px: 0,
        position: "relative",
        touchAction: "pan-y",
      }}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <Box
        sx={{
          display: "flex",
          transition: "transform 0.5s cubic-bezier(.4,0,.2,1)",
          transform: `translateX(${getTranslateX()})`,
          alignItems: "center",
        }}
      >
        {cards.map((card, index) => (
          <Box
            key={card.card_id || index}
            sx={{
              // border: "1px solid red",
              flex: "0 0 75vw",
              mx: "0vw",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              transform: currentIndex === index ? "scale(1)" : "scale(0.92)",
              transition: "transform 0.3s",
              zIndex: currentIndex === index ? 2 : 1,
              
            }}
          >
            {card.isViewAll ? (
              <Box
                sx={{
                  width: "75vw",
                  height: "380px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#e8eaf6",
                  flexDirection: "column",
                  borderRadius: 2,
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                }}
              >
                <Button variant="contained" color="primary">
                  View All Articles
                </Button>
              </Box>
            ) : (
              <BlogCard
                card_image={card.card_image}
                title={card.title}
                tags={card.tags}
                index={index}
              />
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default MobileSlider;
